import { IconName } from '@infotech-soe/erp-ui-kit';

import {
  BuiltinCaptionType,
  Caption,
  CaptionType,
} from '../../../models/caption/Caption';
import { CommandName } from '../CommandViewModel';

import CategoryCommand from './CategoryCommand';

class ClearColumnsFiltersCommand extends CategoryCommand<void> {
  public static COMMAND_NAME = 'clearColumnsFilters' as const;

  public async getCaption(): Promise<Caption> {
    return {
      type: CaptionType.BUILT_IN,
      caption: BuiltinCaptionType.CLEAR_COLUMNS_FILTERS,
    };
  }

  public getIcon(): IconName {
    return 'filter-column-clear';
  }

  public getName(): CommandName {
    return ClearColumnsFiltersCommand.COMMAND_NAME;
  }
}

export default ClearColumnsFiltersCommand;
